module.exports = __webpack_public_path__ + "static/media/dp.2a7f8790.png";